/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { TakedownNoticeDtoFromJSON, TakedownNoticeDtoToJSON, } from '../models/index';
/**
 *
 */
export class TakedownNoticesApi extends runtime.BaseAPI {
    /**
     */
    takedownNoticesSubmitTakedownNoticeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/takedown-notices`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: TakedownNoticeDtoToJSON(requestParameters.takedownNoticeDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TakedownNoticeDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    takedownNoticesSubmitTakedownNotice(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.takedownNoticesSubmitTakedownNoticeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
